import React from "react";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { FaStar, FaRegStar, FaLocationDot } from "react-icons/fa6";
import { MdAccessTimeFilled, MdChevronRight } from "react-icons/md";
import {
  AiOutlineLike,
  AiOutlineDislike,
  AiFillLike,
  AiFillDislike,
} from "react-icons/ai";
import { TbFlag, TbFlagFilled } from "react-icons/tb";

const TrendingReviews = ({
  reviews,
  showReviewModal,
  selectedReview,
  engagements,
  onShowReviewModal,
  onCloseReviewModal,
  onHandleEngagement,
  location,
}) => {
  const isLiked = (reviewId) => Boolean(engagements[reviewId]?.like);
  const isDisliked = (reviewId) => Boolean(engagements[reviewId]?.dislike);

  const getDisplayCounts = (review) => {
    const baseLikes =
      selectedReview && selectedReview.review_id === review.review_id
        ? selectedReview?.likes ?? review?.likes
        : review?.likes;
    const baseDislikes =
      selectedReview && selectedReview.review_id === review.review_id
        ? selectedReview?.dislikes ?? review?.dislikes
        : review?.dislikes;

    let likes = Number(baseLikes ?? 0);
    let dislikes = Number(baseDislikes ?? 0);

    return { likes, dislikes };
  };

  const handleLikeClick = (e, review) => {
    e.stopPropagation();
    if (isLiked(review.review_id) || isDisliked(review.review_id)) return; // prevent re-clicking the same action or switching from dislike
    onHandleEngagement(review, "like");
  };

  const handleDislikeClick = (e, review) => {
    e.stopPropagation();
    if (isDisliked(review.review_id) || isLiked(review.review_id)) return; // prevent re-clicking the same action or switching from like
    onHandleEngagement(review, "dislike");
  };
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) =>
      i < rating ? (
        <FaStar key={i} color="#000000" className="icon_size" />
      ) : (
        <FaRegStar key={i} className="icon_size" />
      )
    );
  };

  const renderReviewCard = (review, index) => {
    const counts = getDisplayCounts(review);
    return (
    <div
      key={index}
      className="col-lg col-md-4 col-sm-6 col-4 mb-lg-2 mb-md-2 mb-2 px-lg-2 px-md-2 px-1 review-item"
      style={{ cursor: "pointer" }}
      onClick={() => onShowReviewModal(review)}
    >
      <div className="d-flex pb-1 align-items-center">
        <p className="mb-0">
          <MdAccessTimeFilled color="#9C9C9C" />
        </p>
        <p className="ps-1 access_time_now pt-1 mb-1 truncate-text">
          {review?.timeAgo}
        </p>

        {review?.is_verified ? (
          <div className="verified-tooltip-trending ms-2">
            <span className="verified-badge-trending">Verified</span>
            <span className="verified-tooltip-text">
              Verified reviews are submitted by individuals who have confirmed
              their employment.
            </span>
          </div>
        ) : (
          <div className="unverified-tooltip-trending ms-2">
            <span className="unverified-badge-trending">Unverified</span>
            <span className="unverified-tooltip-text">
              unverified review will not count towards the manager's official
              rating.
            </span>
          </div>
        )}
      </div>
      <div className="show_review_box ps-lg-4 ps-md-4 ps-2">
        <div className="d-flex justify-content-center flex-column h-100">
          <div className="d-flex align-items-center mb-1 mt--5">
            <div className="company-logo-wrapper me-2">
              {review?.company_logo_url && (
                <img
                  src={review.company_logo_url}
                  alt="Company Logo"
                  className="company-logo-xx"
                />
              )}
            </div>
            <h4
              className="add_review_h4 mb-0 truncate-text"
              style={{ marginTop: "1px" }}
            >
              {review?.company_name && review.company_name.length > 40
                ? review.company_name.slice(0, 40) + "..."
                : review?.company_name}
            </h4>
          </div>
          <h4 className="add_review_p mb-0 mt-1 truncate-text">
            {review?.name && review.name.length > 40
              ? review.name.slice(0, 40) + "..."
              : review?.name}
          </h4>
          <p className="mb-lg-1 mb-md-1 mb-0">{renderStars(review?.rating)}</p>
          <p className="add_review_p mb-0 truncate-text">
            <FaLocationDot color="#000000" className="icon_size" />
            <span className="add_review_p" title={review?.location ?? ""}>
              {review?.location && review.location.length > 40
                ? review.location.slice(0, 40) + "..."
                : review?.location}
            </span>
          </p>
          <p className="d-flex justify-content-end align-items-center add_review_p mb-0 pe-lg-3 pe-md-3 pe-3 pt-2">
            {isLiked(review.review_id) ? (
              <AiFillLike 
                color="#000000" 
                className="me-1" 
                onClick={(e) => handleLikeClick(e, review)}
                style={{ cursor: (isLiked(review.review_id) || isDisliked(review.review_id)) ? "not-allowed" : "pointer" }}
              />
            ) : (
              <AiOutlineLike 
                color="#000000" 
                className="me-1" 
                onClick={(e) => handleLikeClick(e, review)}
                style={{ cursor: (isLiked(review.review_id) || isDisliked(review.review_id)) ? "not-allowed" : "pointer" }}
              />
            )}
            <span className="add_review_p me-1 fw-bold">{counts.likes}</span>
            {isDisliked(review.review_id) ? (
              <AiFillDislike 
                color="#000000" 
                className="me-1" 
                onClick={(e) => handleDislikeClick(e, review)}
                style={{ cursor: (isDisliked(review.review_id) || isLiked(review.review_id)) ? "not-allowed" : "pointer" }}
              />
            ) : (
              <AiOutlineDislike 
                color="#000000" 
                className="me-1" 
                onClick={(e) => handleDislikeClick(e, review)}
                style={{ cursor: (isDisliked(review.review_id) || isLiked(review.review_id)) ? "not-allowed" : "pointer" }}
              />
            )}
            <span className="add_review_p fw-bold">{counts.dislikes}</span>
          </p>
        </div>
      </div>
    </div>
  );
  };

  const renderReviewModal = () => (
    <Modal
      show={showReviewModal}
      onHide={onCloseReviewModal}
      size="lg"
      centered
      dialogClassName="custom-modal"
    >
      {selectedReview && (
        <div className="all_reviews_box">
          <div className="py-3 px-lg-4 px-md-3 px-3">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                <div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <Link
                        to={`/company-profile?name=${encodeURIComponent(
                          selectedReview?.company_name
                        )}&id=${selectedReview?.company_id}`}
                        style={{ textDecoration: "none" }}
                        className="d-flex align-items-center"
                      >
                        {selectedReview?.company_logo_url && (
                          <img
                            src={selectedReview.company_logo_url}
                            alt="Company Logo"
                            style={{
                              height: "40px",
                              borderRadius: "20%",
                              objectFit: "contain",
                              marginRight: "10px",
                              marginBottom: "8px",
                            }}
                          />
                        )}
                        <h4 className="all_reviews_h4 mb-0">
                          {selectedReview?.company_name}
                        </h4>
                      </Link>
                    </div>
                    <div>
                      <div className="d-flex justify-content-end pb-1">
                        <div className="me-2">
                          {selectedReview?.is_verified ? (
                            <div className="verified-tooltip-trending ms-2">
                              <span className="verified-badge-trending">
                                Verified
                              </span>
                              <span className="verified-tooltip-text">
                                Verified reviews are submitted by individuals
                                who have confirmed their employment.
                              </span>
                            </div>
                          ) : (
                            <div className="unverified-tooltip-trending ms-2">
                              <span className="unverified-badge-trending">
                                Unverified
                              </span>
                              <span
                                className="unverified-tooltip-text"
                                style={{ bottom: "-607%" }}
                              >
                                This review is by an unverified user and will
                                not count towards the manager's official rating.
                              </span>
                            </div>
                          )}
                        </div>
                        <p className="mb-0">
                          <MdAccessTimeFilled color="#000000" />
                        </p>
                        <p className="ps-1 access_time_now pt-1 mb-0 pe-2 text-black">
                          {selectedReview?.timeAgo}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="d-lg-flex d-md-flex">
                    <div>
                      <Link
                        style={{ textDecoration: "none" }}
                        to={`/manager?name=${encodeURIComponent(
                          selectedReview?.manager_full_name
                        )}&id=${selectedReview?.manager_id}`}
                      >
                        <h6 className="all_reviews_h6_details fw-bold">
                          {selectedReview?.manager_full_name}
                        </h6>
                      </Link>
                    </div>
                    <div className="border_difference_tags_difference ms-2 me-2"></div>
                    <div>
                      <h6 className="all_reviews_h6_details">
                        {selectedReview?.manager_position}
                      </h6>
                    </div>
                    <div className="border_difference_tags_difference ms-2 me-2"></div>
                    <div>
                      <h6 className="all_reviews_h6_details">
                        {selectedReview?.location}
                      </h6>
                    </div>
                  </div>
                </div>
                <div>
                  <p className="mb-2">{renderStars(selectedReview?.rating)}</p>
                </div>
                <div className="d-flex align-items-center justify-content-between pt-lg-0 pt-md-0 pt-3">
                  <div>
                    <h5 className="mb-0 tags_manager_profile">Tags</h5>
                  </div>
                </div>
                <div className="d-lg-flex d-md-flex align-items-center">
                  <div>
                    <div className="d-flex flex-wrap gap-2 pt-2">
                      {selectedReview?.positive_tags?.map((tag) => (
                        <div
                          key={tag}
                          className="px-3 py-1"
                          style={{
                            backgroundColor: "#EDFDED",
                            color: "#2C2C2C",
                            cursor: "pointer",
                            borderRadius: "30px",
                            fontSize: "0.85em",
                            height: "28px",
                          }}
                        >
                          {tag}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="border_difference_tags ms-2 mt-2"></div>
                  <div>
                    <div className="d-flex flex-wrap gap-2 pt-2 ps-2">
                      {selectedReview?.negative_tags?.map((tag) => (
                        <div
                          key={tag}
                          className="px-3 py-1"
                          style={{
                            backgroundColor: "#FFD0CA",
                            color: "#2C2C2C",
                            cursor: "pointer",
                            fontSize: "0.85em",
                            borderRadius: "30px",
                            height: "28px",
                          }}
                        >
                          {tag}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="manager_reviews_box p-3 mt-lg-4 mt-md-3 mt-3">
                  <p className="manager_reviews_box_p">
                    {selectedReview?.review}
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="d-flex justify-content-between pt-2">
                <div>
                  {isLiked(selectedReview.review_id) ? (
                    <AiFillLike
                      fontSize={22}
                      color="#151515"
                      onClick={(e) => handleLikeClick(e, selectedReview)}
                      style={{ cursor: (isLiked(selectedReview.review_id) || isDisliked(selectedReview.review_id)) ? "not-allowed" : "pointer" }}
                    />
                  ) : (
                    <AiOutlineLike
                      fontSize={22}
                      color="#151515"
                      onClick={(e) => handleLikeClick(e, selectedReview)}
                      style={{ cursor: (isLiked(selectedReview.review_id) || isDisliked(selectedReview.review_id)) ? "not-allowed" : "pointer" }}
                    />
                  )}
                  <span className="add_review_p mx-1 fw-bold pe-2">
                    {getDisplayCounts(selectedReview).likes}
                  </span>
                  {isDisliked(selectedReview.review_id) ? (
                    <AiFillDislike
                      fontSize={22}
                      color="#151515"
                      onClick={(e) =>
                        handleDislikeClick(e, selectedReview)
                      }
                      style={{ cursor: (isDisliked(selectedReview.review_id) || isLiked(selectedReview.review_id)) ? "not-allowed" : "pointer" }}
                    />
                  ) : (
                    <AiOutlineDislike
                      fontSize={22}
                      color="#151515"
                      onClick={(e) =>
                        handleDislikeClick(e, selectedReview)
                      }
                      style={{ cursor: (isDisliked(selectedReview.review_id) || isLiked(selectedReview.review_id)) ? "not-allowed" : "pointer" }}
                    />
                  )}
                  <span className="add_review_p ms-1 fw-bold">
                    {getDisplayCounts(selectedReview).dislikes}
                  </span>
                </div>
                <div>
                  {engagements[selectedReview.review_id]?.reported ? (
                    <TbFlagFilled
                      fontSize={25}
                      color="#000000"
                      onClick={() => {}}
                      style={{ cursor: "not-allowed" }}
                    />
                  ) : (
                    <TbFlag
                      fontSize={25}
                      color="#151515"
                      onClick={() =>
                        onHandleEngagement(selectedReview, "report")
                      }
                      style={{ cursor: "pointer" }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );

  if (location?.pathname !== "/") return null;

  return (
    <div className="px-lg-2 px-md-2 px-3">
      {/* Hover/click animations for the "View More >" CTA */}
      <style>{`
        .view-more-cta{
          display:inline-flex;
          align-items:center;
          gap:.25rem;
          text-decoration:none;
          color:inherit;
          padding:.25rem .5rem;
          border-radius:8px;
          transition: transform .12s ease, box-shadow .2s ease, color .15s ease, text-decoration-color .15s ease;
          will-change: transform;
        }
        .view-more-cta:hover{
          transform: translateY(-1px) scale(1.01);
          box-shadow: 0 6px 16px rgba(0,0,0,.10);
          font-weight:500;
        }
        .view-more-cta:active{
          transform: translateY(0) scale(.98);
          box-shadow: 0 3px 10px rgba(0,0,0,.08);
        }
        .view-more-cta:focus-visible{
          outline:2px solid #111;
          outline-offset:3px;
        }
        .view-more-cta .chev{
          transition: transform .18s ease, color .15s ease;
          color:#9C9C9C;
        }
        .view-more-cta:hover .chev{ transform: translateX(4px); color:#111; }
        .view-more-cta:active .chev{ transform: translateX(6px); }

        @media (prefers-reduced-motion: reduce){
          .view-more-cta, .view-more-cta .chev { transition:none; }
        }
      `}</style>

      <div className="container">
        <div className="row">
          <div className="col-12">
            <h3 className="trending_reviews_h3 pt-3">Trending Reviews</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-lg col-md-4 col-sm-6 col-4 mb-lg-2 mb-md-2 mb-2 px-lg-2 px-md-2 px-1">
            <div className="d-flex pb-1 align-items-center">
              <p className="mb-0">
                <MdAccessTimeFilled color="#FFCB31" className="pt-0" />
              </p>
              <p className="ps-1 access_time_now pt-1 mb-1"> Now </p>
            </div>
            <Link
              to="/add-review"
              style={{ textDecoration: "none", cursor: "pointer" }}
            >
              <div className="add_review_box">
                <div className="d-flex justify-content-center flex-column align-items-center h-100">
                  <h4 className="add_review_h4">+ Add A Review</h4>
                  <p className="add_review_p mb-0 pt-lg-2 pt-md-2 pt-1 text-center">
                    Reviews are Anonymous!
                  </p>
                </div>
              </div>
            </Link>
          </div>
          {reviews?.map((review, index) => renderReviewCard(review, index))}
        </div>

        {/* Updated CTA */}
        <div className="row">
          <div
            className="d-flex justify-content-end align-items-center"
            style={{ fontSize: "14px" }}
          >
            <Link
              to="/all-reviews"
              className="view-more-cta"
              aria-label="View all reviews"
            >
              <span>View More</span>
              <MdChevronRight className="chev" size={16} />
            </Link>
          </div>
        </div>
      </div>
      {renderReviewModal()}
    </div>
  );
};

export default TrendingReviews;